export enum KindCount {
  Tabela,
  TabelaZakresDo,
  Licz,
  TabelaZakresDoPlusWarunek,
  TabelaSpecjanla,
  TabelaWybór,
  TabelaDajLista,
  TabelaWybórTekstTekst,
  TabelaWartoscMax
}
